import Vue from "vue";
import VueRouter from "vue-router";
import { getToken } from "@/utils/auth";

Vue.use(VueRouter);

// 路由表：路径与现行线上一致（hash 模式由 vue-cli 运行时默认）
const routes = [
  { path: "/home", name: "home", meta: { title: "合规立场" }, component: () => import("@/views/home.vue") },
  { path: "/knowledge", name: "knowledge", meta: { title: "AI合规知识库" }, component: () => import("@/views/KnowledgeBase.vue") },
  { path: "/knowledge/search", name: "knowledgeSearch", meta: { title: "专业检索 · AI合规知识库" }, component: () => import("@/views/KnowledgeSearch.vue") },
  { path: "/knowledge/insight", name: "knowledgeInsight", meta: { title: "数据洞察 · AI合规知识库" }, component: () => import("@/views/KnowledgeInsight.vue") },
  { path: "/login", name: "login", meta: { title: "登录" }, component: () => import("@/views/login.vue") },
  { path: "/register", name: "register", meta: { title: "注册" }, component: () => import("@/views/register.vue") },
  { path: "/userAgreement", name: "userAgreement", meta: { title: "用户协议" }, component: () => import("@/views/userAgreement.vue") },
  { path: "/privacyPolicy", name: "privacyPolicy", meta: { title: "隐私政策" }, component: () => import("@/views/privacyPolicy.vue") },
  { path: "/SystemUpgrade", name: "SystemUpgrade", meta: { title: "智能客服" }, component: () => import("@/views/SystemUpgrade.vue") },
  { path: "/verify", name: "verify", meta: { title: "法律意见书验真 - 合规立场" }, component: () => import("@/views/verify.vue") },
  { path: "/feedback", name: "feedback", meta: { title: "反馈 - 合规立场" }, component: () => import("@/views/feedback.vue") },
  {
    path: "/",
    component: () => import("@/components/Layout.vue"),
    redirect: () => (getToken() ? "/project" : "/home"),
    meta: { title: "首页" },
    children: [
      { path: "project", name: "project", component: () => import("@/views/project/index.vue"), meta: { title: "信息总览" } },
      { path: "settings", name: "settings", component: () => import("@/views/settings/index.vue"), meta: { title: "信息总览" } },
      { path: "dataBoard", name: "dataBoard", component: () => import("@/views/dataBoard/index.vue"), meta: { title: "信息总览" } },
      { path: "lawSourceBoard", name: "lawSourceBoard", component: () => import("@/views/lawSourceBoard/index.vue"), meta: { title: "法源库数据看板" } },
      { path: "addProject", name: "addProject", component: () => import("@/views/project/addProject.vue"), meta: { title: "信息总览" } },
      { path: "ProjectDetail", name: "ProjectDetail", component: () => import("@/views/project/ProjectDetail.vue"), meta: { title: "信息总览" } },
      { path: "ProjectReport", name: "ProjectReport", component: () => import("@/views/project/ProjectReport.vue"), meta: { title: "信息总览" } },
      { path: "ProjectReportDetail", name: "ProjectReportDetail", component: () => import("@/views/project/ProjectReportDetail.vue"), meta: { title: "信息总览" } },
      { path: "explanation", name: "explanation", component: () => import("@/views/project/explanation.vue"), meta: { title: "信息总览" } },
      { path: "evaluation", name: "evaluation", component: () => import("@/views/project/evaluation.vue"), meta: { title: "信息总览" } },
      { path: "document", name: "document", component: () => import("@/views/project/document.vue"), meta: { title: "信息总览" } },
      { path: "lawyerWorkbench", name: "lawyerWorkbench", component: () => import("@/views/project/LawyerWorkbench.vue"), meta: { title: "律师复核工作台" } },
      { path: "orgCenter", name: "orgCenter", component: () => import("@/views/project/OrgCenter.vue"), meta: { title: "企业协作" } },
      { path: "docCenter", name: "docCenter", component: () => import("@/views/project/DocCenter.vue"), meta: { title: "合规文档中心" } },
      { path: "filingCenter", name: "filingCenter", component: () => import("@/views/project/FilingCenter.vue"), meta: { title: "备案辅助工作台" } },
      { path: "openApi", name: "openApi", component: () => import("@/views/settings/OpenApi.vue"), meta: { title: "开放API管理" } },
      { path: "uploadAssess", name: "uploadAssess", component: () => import("@/views/project/UploadAssess.vue"), meta: { title: "上传资料智能体检" } },
      { path: "system/feedback", name: "systemFeedback", component: () => import("@/views/system/FeedbackManage.vue"), meta: { title: "反馈管理" } },
      { path: "system/orders", name: "systemOrderManage", component: () => import("@/views/system/OrderManage.vue"), meta: { title: "订单与支付管理" } },
      { path: "system/supportStats", name: "systemSupportStats", component: () => import("@/views/system/SupportStats.vue"), meta: { title: "支撑平台运行的项目统计" } },
      { path: "system/traffic", name: "systemTraffic", component: () => import("@/views/system/TrafficReport.vue"), meta: { title: "平台流量总览" } },
    ],
  },
  { path: "*", name: "notFound", meta: { title: "页面未找到" }, component: () => import("@/views/NotFound.vue") },
];

const router = new VueRouter({
  routes,
});

// 每路由动态 TDK + 知识库 noindex（与现行 SEO 口径一致）
const BASE_TITLE = "合规立场-AI应用合规风险智能感知与治理平台";
router.afterEach((to) => {
  const t = to.meta && to.meta.title;
  if (!t) {
    document.title = BASE_TITLE;
  } else if (t.includes("合规立场") || t === "合规立场") {
    document.title = t === "合规立场" ? BASE_TITLE : t;
  } else {
    document.title = `${t} - 合规立场`;
  }

  let robotsMeta = document.querySelector('meta[name="robots"][data-dyn]');
  if (to.path.indexOf("/knowledge") === 0) {
    if (!robotsMeta) {
      robotsMeta = document.createElement("meta");
      robotsMeta.setAttribute("name", "robots");
      robotsMeta.setAttribute("content", "noindex, nofollow");
      robotsMeta.setAttribute("data-dyn", "1");
      document.head.appendChild(robotsMeta);
    }
  } else if (robotsMeta) {
    robotsMeta.parentNode.removeChild(robotsMeta);
  }
});

export default router;
